'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/common/TicketTypeName.tsx
import { useTranslation } from "@wbk/config";
import { Typography } from "@wbk/ui";
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
var TicketTypeName = ({ zone, ticket, typographyProps, showIcon = false, className }) => {
  var _a, _b, _c;
  const { t } = useTranslation("ticketing_booking");
  const includesEntry = !!zone && !(ticket == null ? void 0 : ticket.requires_entry_ticket);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: twMerge(
        "text-text-secondary data-[zone=true]:text-notice flex items-center gap-2 text-sm",
        className
      ),
      "data-zone": includesEntry,
      children: [
        !!((_a = ticket == null ? void 0 : ticket.subscription_ticket_type) == null ? void 0 : _a.icon) && showIcon && /* @__PURE__ */ jsx("img", { src: ticket.subscription_ticket_type.icon, alt: "", className: "h-5 w-5" }),
        /* @__PURE__ */ jsxs(Typography, __spreadProps(__spreadValues({}, typographyProps), { children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              style: {
                color: includesEntry ? "" : (_b = ticket == null ? void 0 : ticket.subscription_ticket_type) == null ? void 0 : _b.background_color
              },
              children: (_c = ticket == null ? void 0 : ticket.subscription_ticket_type) == null ? void 0 : _c.title
            }
          ),
          includesEntry && ` ${t("ticketing_booking:zone_entry.plus_zone_entry")}`
        ] }))
      ]
    }
  );
};
var TicketTypeName_default = TicketTypeName;

export {
  TicketTypeName_default
};
//# sourceMappingURL=chunk-B7WBL44R.mjs.map